import CheckboxControl from "./components/checkbox";
import ColorPickerControl from "./components/color";
import DateTimeControl from "./components/dateTime";
import ControlHelperText from "./components/helperText";
import ControlLabel from "./components/label";
import NumberControl from "./components/number";
import SelectControl from "./components/select";
import SliderControl from "./components/slider";
import TextControl from "./components/text";
import ControlTooltip from "./components/tooltip";
import ControlBase from "./control";

export type * from "./types";

const Control = Object.assign(ControlBase, {
  Checkbox: CheckboxControl,
  Color: ColorPickerControl,
  DateTime: DateTimeControl,
  HelperText: ControlHelperText,
  Label: ControlLabel,
  Number: NumberControl,
  Select: SelectControl,
  Slider: SliderControl,
  Text: TextControl,
  Tooltip: ControlTooltip,
});

export default Control;
